import { Action, Dispatch } from 'redux'
import { hideLoadingAction } from 'reducks/loading/actions'

const hideLoading = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(hideLoadingAction())
  }
}

export default hideLoading
